export default "__VITE_ASSET__B$gscWCf__"